import React from "react";
import Consumer from "../AppProvider";

class SignIn extends React.Component {
  state = {
    userName: "",
    password: ""
  };
  handleChange = prop => event => {
    this.setState({ [prop]: event.target.value });
  };
  render() {
    return (
      <Consumer>
        {ctx => {
          return (
            <section className="authentication-form">
              <nav className="navbar navbar-expand-lg navbar-light theme-nav fixed-top">
                <div id="navbar-main" className="container">
                  <a
                    className="navbar-brand"
                    href={`${process.env.PUBLIC_URL}/`}
                  >
                    <img src="assets/images/logo.png" alt="logo" />
                  </a>
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon" />
                  </button>
                  <div
                    className="collapse navbar-collapse default-nav"
                    id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav ml-auto" id="mymenu">
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          href={`${process.env.PUBLIC_URL}/`}
                        >
                          Αρχικη
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
              <div className="innerpage-decor">
                <div className="innerpage-circle1">
                  <img src="assets/images/Testimonial2.png" alt="" />
                </div>
                <div className="innerpage-circle2">
                  <img src="assets/images/Testimonial1.png" alt="" />
                </div>
              </div>
              <div>
                <h2 className="title text-center">
                  <span> ΣΥΝΔΕΣΗ</span>
                </h2>
                <p className="text-center">
                  Συμπληρώστε τα παρακάτω πεδία για να συνδεθείτε.
                </p>
                <div className="card">
                  <form
                    className="theme-form"
                    onSubmit={e =>
                      ctx.handleLogin(
                        e,
                        this.state.userName,
                        this.state.password,
                        this.props.history
                      )
                    }
                  >
                    <div className="form-group">
                      <input
                        value={this.state.userName}
                        type="text"
                        className="form-control"
                        placeholder="Όνομα Χρήστη ή E-mail"
                        required="required"
                        onChange={this.handleChange("userName")}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        value={this.state.password}
                        required=""
                        name="login[password]"
                        type="password"
                        className="form-control"
                        placeholder="Κωδικός"
                        onChange={this.handleChange("password")}
                      />
                      <div className="show-hide">
                        <span className="show" />
                      </div>
                    </div>
                    {ctx.errMsg !== "" && (
                      <div className="alert alert-warning alert-dismissible fade show">
                        {ctx.errMsg}{" "}
                        <button
                          type="button"
                          className="close"
                          data-dismiss="alert"
                        >
                          &times;
                        </button>
                      </div>
                    )}
                    <div className="form-group row">
                      {/* <div className="custom-control custom-checkbox col-6">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="customControlAutosizing"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customControlAutosizing"
                        >
                          Remember me
                        </label>
                      </div> */}
                      <a
                        href="https://api.qrstand.gr/wp-login.php?action=lostpassword"
                        className="text-right col-6 theme-link"
                      >
                        Ξεχάσατε τον κωδικό;
                      </a>
                    </div>
                    <div className="form-button text-center">
                      <a
                        href={`${process.env.PUBLIC_URL}/sign-up`}
                        className="btn btn-custom btn-lg signup theme-color"
                      >
                        Εγγραφη
                      </a>
                      <button
                        type="submit"
                        className="btn btn-custom btn-lg signin theme-color"
                      >
                        Συνδεση
                      </button>
                    </div>
                    {/* <div className="or-saparator"><span>or</span></div>
                              <h6 className="text-center mt-0 mb-3">Sign in with:</h6> */}
                    {/* <div className="form-button text-center social-btns">
                                 <button type="submit" className="btn btn-custom fb">Facebook</button>
                                 <button type="submit" className="btn btn-custom ggl">Google</button>
                              </div> */}
                  </form>
                </div>
              </div>
            </section>
          );
        }}
      </Consumer>
    );
  }
}

export default SignIn;



// WEBPACK FOOTER //
// ./src/pages/sign-in.js